export default "__VITE_ASSET__865f97f5__"